module.exports = __webpack_public_path__ + "static/media/gestión_de_viaje.7019a34c.jpg";